import { Table, TableProvider, usePaginatedData } from '@optimus-web/core';
import { useUrlSyncedTableState } from '@mews/framework';
import { ExportItem } from '@mews-commander/data-access';
import { useExports } from '../useExports';
import { ExportFilterValues } from '../types';
import { useColumns } from './tableMapping';

interface ExportsTableProps {
    filters: ExportFilterValues;
}

export const ExportsTable = ({ filters }: ExportsTableProps) => {
    const columns = useColumns();
    const [tableState, setTableState] = useUrlSyncedTableState<ExportItem>({ columns });
    const { startDate, endDate, states, reportType, ownerProfileId } = filters;
    const { data, isFetching } = useExports(
        startDate,
        endDate,
        states || null,
        reportType || null,
        ownerProfileId || null
    );
    const paginatedData = usePaginatedData(data?.exports || [], tableState.pagination);

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <Table
                amountOfRows={paginatedData.totalRowCount}
                data={paginatedData.data}
                fixedFirstColumn
                fixedLastColumn
                loading={isFetching}
                uniqueRowId="id"
            />
        </TableProvider>
    );
};
